import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://github.com/yash2026"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="uil uil-github-alt"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/yashpal-kumar-9b785b1a6/"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="uil uil-linkedin-alt"></i>
      </a>
      <a
        href="https://twitter.com/its21yash"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="uil uil-twitter-alt"></i>
      </a>
      <a
        href="https://www.instagram.com/its21yash/"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="uil uil-instagram"></i>
      </a>
    </div>
  );
};

export default Social;
